// @ts-nocheck
import React, { FC, useState } from "react";
import { PageProps } from "../Page.model";
import {
  IonButton,
  IonContent,
  IonPage,
  IonSpinner,
  IonItem,
  IonCheckbox,
  IonLabel,
  IonIcon,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
  IonCardContent
} from "@ionic/react";
import { cardOutline, timerOutline, walletOutline } from 'ionicons/icons';
import { PaymentInfo, CreditCardForm } from "../../components";
import AddressAutoComplete from '../../components/AddressAutocomplete';
import './Fuel.css'
import { useRecoilValue, useSetRecoilState } from "recoil";
import { userState, alertState } from "../../atoms";
import { getAuth } from "firebase/auth";
import { handleErrors } from "../../utils/handleErrors";

const Fuel: FC<PageProps> = ({ show }) => {
  
  const user = useRecoilValue(userState);
  const setUser = useSetRecoilState(userState);
  const setAlertData = useSetRecoilState(alertState);
  
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [termsAccepted, setTermsAccepted] = useState<boolean>(false);
  const [cardRequested, setCardRequested] = useState<boolean>(false);
  const [mailingAddress, setMailingAddress] = useState<String>(user?.address);
  
  const submitFuelCardRequest = () => {
    setSubmitting(true);
    getAuth().currentUser.getIdToken().then(token => 
      fetch(user._links.self.href + '/fuelCard', {
        method: 'POST',
        body: JSON.stringify({mailingAddress}),
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if(response.status === 402) {
          setUser({
            ...user,
            hasPaymentMethod: false
          });
          setAlertData({
            isOpen:true,
            title:'Payment error',
            subTitle:'Failed to take hold on credit card. Please make sure your card details are valid and that you have sufficient funds available.'
          });
        } else {
          setCardRequested(true);
          setAlertData({
            isOpen:true,
            title:'Fuel card requested',
            subTitle:<>
              <div>Your fuel card request has been received. Your fuel card will be sent to {mailingAddress}.<br/><br/></div>
              <div>If you have any questions, please <a href="mailto:hello@bilsmoov.com.au" target="_blank" rel="noreferrer">contact us</a>.</div>
            </>
          });
        }
      })
      .catch(() => setAlertData({
        isOpen:true,
        title:'Error requesting fuel card',
        subTitle:'Something went wrong. Please try again or contact us.'
      }))
      .finally(() => setSubmitting(false)));
  }
  
  const setUserAddress = address => {
    setMailingAddress(address);
    if(!user?.address) {
      getAuth().currentUser.getIdToken().then(token => 
        fetch(user._links.self.href, {
          method: 'PATCH',
          body: JSON.stringify({address}),
          headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'application/merge-patch+json'
          }
        })
        .then(handleErrors)
        .then(updatedUser => setUser({
          ...user,
          address
        })));
    }
  }
  
  return show && (
    <IonPage>
      <PaymentInfo />
      
      <IonContent className="fuel-content">
        <h2>Shell Fuel Card</h2>
        
        <IonItem lines="none">
          We have partnered with Shell to offer savings and smooth payments at their 1,250 sites.
        </IonItem>
        
        <div>
          <IonCard color="light" className="fuel-benefit">
            <IonCardHeader>
              <IonCardTitle><IonIcon icon={cardOutline} color="primary" size="large" className="fuel-benefit-icon" />Save money</IonCardTitle>
              <IonCardSubtitle>4 cents per litre</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              Get 4 cents per litre off your fuel. Every time. No coupons needed.
            </IonCardContent>
          </IonCard>
          <IonCard color="light" className="fuel-benefit">
            <IonCardHeader>
              <IonCardTitle><IonIcon icon={timerOutline} color="primary" size="large" className="fuel-benefit-icon" />Save time</IonCardTitle>
              <IonCardSubtitle>Pay at the bowser</IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              No need to queue up in the shop. Pay at the bowser with your Shell Card Go app.
            </IonCardContent>
          </IonCard>
          { user?.paymentOption === 'SMOOV' && 
            <IonCard color="light" className="fuel-benefit">
              <IonCardHeader>
                <IonCardTitle><IonIcon icon={walletOutline} color="primary" size="large" className="fuel-benefit-icon" />Smoov payments</IonCardTitle>
                <IonCardSubtitle>Pay in weekly installments</IonCardSubtitle>
              </IonCardHeader>
              <IonCardContent>
                Pay for your fuel in smoov, weekly installments.
              </IonCardContent>
            </IonCard>
          }
        </div>
        
        <div className="fuel-form">
        
          { !user?.hasPaymentMethod &&
            <>
              <p>In order to apply for a fuel card we require a valid credit card on file</p>
              <div className="cc-form">
                <CreditCardForm />
              </div>
            </>
          }
          
          <div className="mailing-address">
            Mailing address &nbsp;<small style={{color:'grey'}}>(to send your fuel card)</small>
            <AddressAutoComplete style={{width:'100%'}}
              initialAddress={user?.address}
              onAddressUpdate={address => setUserAddress(address)} />
          </div>
          
          <div className="terms">
            <IonItem lines="none">
              <IonCheckbox value={termsAccepted} onIonChange={() => setTermsAccepted(!termsAccepted)} className="terms-checkbox" />
              <IonLabel className="terms-label">I acknowledge that my fuel expenses will be automatically added to my payments and that Billsmoov will take a $100 hold on my card until my first fuel purchase</IonLabel>
            </IonItem>
          </div>
          
          <IonButton size="large" className="fuel-submit" 
            disabled={cardRequested || !termsAccepted || !mailingAddress || !user?.hasPaymentMethod} onClick={submitFuelCardRequest}>
            {submitting && <IonSpinner name="dots" />} {cardRequested ? 'Fuel card requested' : 'Send fuel card'}
          </IonButton>
        </div>
        
      </IonContent>
    </IonPage>
  )
}

export default Fuel